import styled from "styled-components"

export const Container = styled.div`
    margin: 20px;
    padding: 20px;
    border-radius: 10px;
    -webkit-box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.9);
    box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.9);
    background-color: var(--darkGrey);
`

export const Title = styled.h3`
    margin-bottom: 20px;
    color: var(--lightGrey);
`